import React from "react";
import { Bone, Scissors } from "lucide-react";
import { cn } from "@/lib/utils";

export function AIEngineSelector({ value, onChange, size = "md", testIdPrefix = "specialty" }) {
  const opts = [
    { value: "orthopedics", label: "Orthopedic AI", icon: Bone, testId: `${testIdPrefix}-orthopedics` },
    { value: "general_surgery", label: "General Surgery AI", icon: Scissors, testId: `${testIdPrefix}-general-surgery` },
  ];
  const pad = size === "sm" ? "text-xs px-3 py-1.5" : "text-sm px-4 py-2";
  return (
    <div
      role="tablist"
      aria-label="AI Engine"
      data-testid="ai-engine-selector"
      className={cn(
        "inline-flex items-center gap-1 rounded-full p-1 border",
        "bg-secondary border-border"
      )}
    >
      {opts.map((o) => {
        const active = value === o.value;
        return (
          <button
            key={o.value}
            role="tab"
            aria-selected={active}
            data-testid={o.testId}
            onClick={() => onChange(o.value)}
            className={cn(
              "inline-flex items-center gap-1.5 font-medium rounded-full transition-all",
              pad,
              active
                ? "bg-card text-foreground shadow-sm border border-border"
                : "text-muted-foreground hover:text-foreground"
            )}
          >
            <o.icon className="w-3.5 h-3.5" />
            {o.label}
          </button>
        );
      })}
    </div>
  );
}
